import React from 'react'

function DoubleStripes() {
    return (
        <pattern
            id="double-stripes"
            width="16"
            height="8"
            patternUnits="userSpaceOnUse"
            patternTransform="rotate(45)"
        >
            <rect
                key="rect_1"
                width="1"
                height="8"
                opacity=".5"
                transform="translate(0,0)"
                fill="#f5f5f5"
            />
            <rect
                key="rect_2"
                width="1"
                height="8"
                opacity=".5"
                transform="translate(8,0)"
                fill="#b2dfdb"
            />
        </pattern>
    )
}

export default DoubleStripes
